export const StatusKeysToDisplay: string[] = [
  'new',
  'accepted',
  'production',
  'held',
  'shipped',
  'cancelled',
  'rejected'
];
